import { createSelector } from 'reselect'
import { isAbandonedCart, isHotLead, isRecentlyViewed, isPriceMissing, shouldDisplayAsRecentlyViewed } from 'lib/offer/highIntentOffers'
import { isHotelType, isTourOfferType, isTourV2OfferType } from 'lib/offer/offerTypes'
import { isLereEnabled } from 'lib/lere/isLereEnabled'

export const getAllAbandonedCarts = createSelector(
  (state: App.State) => state.recommendations.highIntent.offers,
  (highIntentOffers) => highIntentOffers.filter(isAbandonedCart),
)

export const getHighIntentOffers = createSelector(
  (state: App.State) => state.recommendations.highIntent.offers,
  (offers) => {
    if (!isLereEnabled()) { return [] }
    return offers.filter(offer => isAbandonedCart(offer) || isRecentlyViewed(offer) && !isPriceMissing(offer) || isHotLead(offer) && isHotelType(offer.offerType) || shouldDisplayAsRecentlyViewed(offer))
  },
)

export const getHighIntentOfferIds = createSelector(
  (state: App.State) => getHighIntentOffers(state),
  (highIntentOffers: Array<App.HighIntentOffer>) => highIntentOffers.map(offer => offer.offerId),
)

// used for high intent carousel
export const getHighIntentTourOffers = createSelector(
  (state: App.State) => getHighIntentOffers(state),
  (offers: Array<App.HighIntentOffer>) => offers
    .filter(offer => isTourV2OfferType(offer.offerType)),
)

// used for tour carousel on the homepage
export const getHighIntentTours = createSelector(
  (state: App.State) => state.recommendations.highIntent.offers,
  (offers: Array<App.HighIntentOffer>): Array<App.HighIntentOffer> => offers.filter(offer => isTourV2OfferType(offer.offerType)),
)

export const getHighIntentHotelOffers = createSelector(
  (state: App.State) => getHighIntentOffers(state),
  (offers: Array<App.HighIntentOffer>) => offers.filter(offer => isHotelType(offer.offerType)),
)
export const getHighIntentHotelAndTourOffers = createSelector(
  (state: App.State) => getHighIntentOffers(state),
  (offers: Array<App.HighIntentOffer>) => offers.filter(offer => isTourOfferType(offer.offerType) || isHotelType(offer.offerType)),
)
export const getHighIntentHotelOfferIds = createSelector(
  (state: App.State) => getHighIntentHotelOffers(state),
  (offers: Array<App.HighIntentOffer>) => offers.map(offer => offer.offerId),
)

export const getRecentlyViewedOffers = createSelector(
  (state: App.State) => getHighIntentHotelOffers(state),
  (offers: Array<App.HighIntentOffer>) => offers.filter(isRecentlyViewed),
)
